import { createSelector, MemoizedSelector } from '@ngrx/store';
import { SelectedPrice } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { ProductState, StateWithProduct } from '../product-state';
import { getCustomProductState } from './feature.selector';

type SelectedPriceState = ProductState['selectedPrice'];

export const getSelectedPriceEntityState: MemoizedSelector<StateWithProduct, SelectedPriceState> = createSelector(
  getCustomProductState,
  (state: ProductState) => state.selectedPrice,
);

export const getSelectedPriceValue = (code: string): MemoizedSelector<StateWithProduct, SelectedPrice> =>
  createSelector(getSelectedPriceEntityState, (state) => StateUtils.entityValueSelector(state, code));
